import { useText } from "@sveabank/cc-common";
import usePackageTitle from "../../../components/review-section/usePackageTitle";
import type { OnboardingPackageId } from "../../../types/package";
import type { CostSummaryItem } from "../helpers";

type Props = {
	costSummaryArray: CostSummaryItem[];
	selectedPackageId: OnboardingPackageId;
};

const CreditConfigPageTable = ({ costSummaryArray, selectedPackageId }: Props) => {
	const [t, texts] = useText();

	const packageTitle = usePackageTitle(selectedPackageId);

	return (
		<table className="w-full pt-6">
			<tbody>
				{costSummaryArray.map((item) => {
					const [id, sku, cost] = item;
					const addonText = texts.addons[sku as keyof typeof texts.addons];
					let titleText = "";

					switch (id) {
						case selectedPackageId:
							titleText = packageTitle;
							break;

						case "CHECKKREDIT":
							titleText = "title" in addonText ? t(addonText.title) : "";
							break;

						case "CREDITCARD":
							titleText = "extraCreditCards" in addonText ? t(addonText.extraCreditCards) : "";
							break;

						default:
							titleText = "";
					}

					return (
						<tr key={id}>
							<td className="border-b-2 border-solid py-2">{titleText}</td>
							<td className="border-b-2 py-2 text-right align-top whitespace-nowrap">
								{t(texts.adjustCredit.costSummary.subCost, cost.toString())}
							</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	);
};

export default CreditConfigPageTable;
